export const PAGE_ID = 'page_id'

export const initialValues = {
  [PAGE_ID]: ''
}
